<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onClickReset)" autocomplete="off">
            <div slot="no-body" class="full-page-bg-color">
              <div class="vx-row">
                <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                  <img src="@/assets/images/logo/its_logo_horizontal.png" alt="login" class="mx-auto" width="250">
                </div>
                <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                  <div class="p-8">
                    <div class="vx-card__title mb-4 text-center">
                      <h4 class="mb-4">Scan & Enter your 2-step verification code</h4>
                      <p>A 6-digit code is generated by your phone.</p>
                    </div>

                    <div class="flex flex-wrap items-center justify-center mt-2 mb-4 ">
                      <img width="200" :src="google_2fa_url" />
                    </div>

                    <div class="mb-3 vx-row">
                      <div class="w-full vx-col md:w-full md:mb-0">
                        <ValidationProvider vid="name" name="name" rules="required|min:6|max:6" v-slot="{ errors }">
                          <small class="label">Code</small>
                          <vs-input v-model="secret_code" name="name" class="w-full" label="" :danger="!!errors[0]"
                            :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                      <vs-button type="border" to="/pages/login"
                        class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go
                        Back To Login
                      </vs-button>
                      <vs-button button="submit" class="w-full sm:w-auto">Enable</vs-button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import store from "../../store/store";

const SupplierRepository = RepositoryFactory.get('supplier');
const CustomerRepository = RepositoryFactory.get('customer');

export default {
  mixins: [SuccessMessage, ErrorMessages],
  name: 'Customer2FA',
  data() {
    return {
      form: {
        email: '',
        password: '',
        password_confirmation: '',
        token: '',
      },
      google_2fa_url: '',
      secret_code: '',
    }
  },
  async mounted() {
    this.google_2fa_url = ''
    this.$vs.loading();
    try {
      const { data } = (await CustomerRepository.get2FAImageQR(this.$store.getters.currentUser.id)).data;
      this.google_2fa_url = data.google_2fa_url
    } catch (err) {
      console.log(err)
      this.convertAndNotifyError(err)
    }
    this.$vs.loading.close()
  },
  methods: {
    async onClickReset() {
      this.$vs.loading();
      try {
        await CustomerRepository.enable2FA(this.$store.getters.currentUser.id, { secret: this.secret_code })
        this.showSuccessMessage('2FA enabled successfully!');
        this.$store.dispatch('autoLogin')
        window.location = '/';
      } catch (err) {
        console.log(err);
        this.convertAndNotifyError(err)
      }
      this.$vs.loading.close()
    },
    async getPasswordToken() {

    }
  }
}
</script>
